module.exports = __webpack_public_path__ + "static/media/stats.7f6b3a0d.svg";